import { GenericServiceRequest } from './generic-service-request';
import { FindValuesOptions } from '../domain-models/find-options/find-values-options';


export class FindValuesExternalRequest extends GenericServiceRequest<FindValuesOptions> {

}
